export default __webpack_public_path__ + "static/OfficeOverHeadShot-6d46daed3e97adb1f570f09b22b71e12.png";